const buttonSelector = '.remove-link';
const buttunSelectorTwo = '.remove-kit-link'

const FREEGIFTOBJ = ABV4_SETTINGS.free_gift

export class FreeGift {
    constructor(api, cart) {
        if (!FREEGIFTOBJ.free_products) {
            return;
        }
        this.freeGift = FREEGIFTOBJ;
        this.api = api;
        this.cart = cart;
        this.matchedProducts = null;
        this.fetchCart = this.fetchCart.bind(this);
        this.handleFreeGift = this.handleFreeGift.bind(this);
        this.addToCart = this.addToCart.bind(this);
        this.handleQuantityChange = this.handleQuantityChange.bind(this);
        this.handleFreeGiftTest = this.handleFreeGiftTest.bind(this);
        this.fetchCart();
        const cartLineItems = $('.line-items-wrapper').find('.line-item-wrapper .line-item');
        for (let i = 0; i < cartLineItems.length; i++) {
            const lineItem = $(cartLineItems[i]);
            const variantId = lineItem.find('[name="variant_id[' + i + ']"]').val();
            if (FREEGIFTOBJ.free_products_condition === 'all') {
                const qs = lineItem.find('.v4-quantity-selector .step-button');
                qs.on('click', this.handleQuantityChange)
            } else {
                const qs = lineItem.find('.v4-quantity-selector .step-button');
                qs.on('click', this.handleQuantityChange)
            }
        }
    }

    handleQuantityChange() {
        const {free_products_condition} = this.freeGift;
        const _this = this;
        setTimeout(() => {
            _this.fetchCart();
        }, 200);
    }

    fetchCart() {
        setTimeout(() => {
            this.api.cart().then(this.handleFreeGift);
        }, 600);
    }

    handleFreeGift(data) {
        const {free_products_condition} = this.freeGift;
        this.matchedProducts = this.handleCart(data, free_products_condition);
        const matchedProducts = this.matchedProducts;
        this.handleFreeGiftTest(this.matchedProducts);
    }

    handleFreeGiftTest(matchedProducts) {
        const {
            free_products_id,
            free_products_quantity,
            free_products_multiply_on,
            free_products_condition
        } = this.freeGift;

        if ((matchedProducts['productsQtyInCart'] === 0 && matchedProducts['freeProductCount'] > 0) || (matchedProducts['freeProductCount'] > 0 && matchedProducts['productsQtyInCart'] < free_products_multiply_on)) {
            const freeProductKey = matchedProducts['freeProductCartKey'];
            let updates = {};
            updates[freeProductKey] = 0;
            this.api.cartUpdate({updates}).then(() => {
                // $('.free-gift.line-item-wrapper').remove();
                window.location.reload();
            })
        } else if (matchedProducts['productsQtyInCart'] > 0 && free_products_multiply_on !== false) {
            const multyplyOn = this.freeProductsPerLineItem(matchedProducts, free_products_multiply_on, free_products_quantity);
            if (multyplyOn && multyplyOn > 0 && matchedProducts['freeProductCount'] !== multyplyOn) {
                const qtyForFreeProduct = multyplyOn;
                if (matchedProducts['freeProductCartKey'] !== '') {
                    let updates = {};
                    updates[matchedProducts['freeProductCartKey']] = multyplyOn;
                    const _this = this;
                    setTimeout(() => {
                        _this.api.cartUpdate({updates}).then(() => {
                            $('.line-items-wrapper .free-gift').find('.quantity .quantity-block .qty').text(multyplyOn)
                        });
                    }, 0);
                } else {
                    this.addToCart(free_products_id, qtyForFreeProduct);
                }
            }
        } else if (matchedProducts['productsQtyInCart'] > 0 && matchedProducts['productsQtyInCart'] >= free_products_multiply_on && matchedProducts['freeProductCount'] == 0) {
            this.addToCart(free_products_id, free_products_quantity);
        } else if (matchedProducts['productsQtyInCart'] > 0 && matchedProducts['freeProductCount'] == 0 && !free_products_multiply_on) {
            this.addToCart(free_products_id, free_products_quantity);
        }
    }

    addToCart(productId, qty) {
        this.api.addToCart({
            items: [
                {
                    id: productId,
                    quantity: qty,
                    properties: {
                        "_bundle": 'free gift',
                        "_bundle_discount": 100,
                        "_free_gift": true
                    }
                }
            ]
        }).then((data) => {
            const {key, featured_image, image, url, title, product_type, product_id, quantity, id} = data.items[0];
            const {alt, aspect_ratio, height, width} = featured_image;
            const placeholder = $('.line-items-wrapper .free-gift');
            placeholder.removeClass('d-none');
            placeholder.find('.line-item-free-gift').addClass('line-item');
            placeholder.find('.line-item-free-gift').attr('data-item-key', key);
            const imageHtml = placeholder.find('.image-frame img');
            imageHtml.attr('data-src', image);
            placeholder.find('.item .item-details .collections').text(product_type);
            placeholder.find('.item .item-details .item-title a').attr('href', url);
            placeholder.find('.item .item-details .item-title a').text(title);
            // placeholder.find('.item .item-details input[name="product_id[]"]').attr('name', 'product_id['+  +']');
            // placeholder.find('.item .item-details input[name="variant_id[]"]').attr('name', 'variant_id['+ id +']');
            // placeholder.find('.item .item-details input[name="quantity[]"]').attr('name', 'quantity['+ quantity +']');
            placeholder.find('.quantity .quantity-block .qty').text(quantity);
            placeholder.find('.total .pricing-block .item-total2').text("FREE");
        });
    }

    freeProductsPerLineItem(matchedProducts, freeProductsMultiplyOn, freeProductsQuantity) {
        const cartQty = matchedProducts['productsQtyInCart'];
        const freeCartQty = matchedProducts['freeProductCount'];
        const freeLineItemQty = cartQty / freeProductsMultiplyOn;
        let finalFreeLineItemQty = 0;
        finalFreeLineItemQty = parseInt(freeLineItemQty) * freeProductsQuantity;
        if (finalFreeLineItemQty < 1) {
            return false;
        } else {
            return finalFreeLineItemQty;
        }
    }


    handleCart(cartData, productsCondition) {
        const {items} = cartData;
        let result = {
            "freeProductCount": 0,
            "productsQtyInCart": 0,
            "freeProductCartKey": ''
        };
        let freeProductsInCart = 0;
        let productsQtyInCart = 0;

        for (const lineItem of items) {
            // if (lineItem.properties.hasOwnProperty('free_gift')) {
                if (!lineItem.properties.hasOwnProperty('_free_gift')) {
                    if (!lineItem.properties.hasOwnProperty('_bundle') && productsCondition.indexOf(lineItem.variant_id) !== -1 && productsCondition !== 'all') {
                        productsQtyInCart += lineItem.quantity;
                        result['productsQtyInCart'] = productsQtyInCart;
                    } else if (!lineItem.properties.hasOwnProperty('_bundle') && productsCondition === 'all') {
                        productsQtyInCart += lineItem.quantity;
                        result['productsQtyInCart'] = productsQtyInCart;
                    } else if (lineItem.properties.hasOwnProperty('_bundle') && productsCondition.indexOf(lineItem.properties._bundle_class) !== -1) {
                        productsQtyInCart += lineItem.quantity;
                        result['productsQtyInCart'] = lineItem.quantity;
                    }
                } else {
                    if (lineItem.properties.hasOwnProperty('_free_gift')) {
                        result['freeProductCartKey'] = lineItem.key;
                    }
                    freeProductsInCart += lineItem.quantity;
                    result['freeProductCount'] = freeProductsInCart;
                }
            // }
        }

        return result;
    }

    // freeProductHandle(data) {
    //     const cartVariants = this.getCartVariants(data);
    //     let addFreeProduct = false;
    //     if (cartVariants.length === 0) return false;
    //     // if(freeProductSoldOut) return  false;
    //     if (data.items.length !== 0) {
    //         data.items.forEach((item) => {
    //             if (cartVariants.indexOf(birthday_sale_free_prod.id) === -1 && !item.properties.hasOwnProperty('ashley_birthday')) {
    //                 addFreeProduct = true;
    //             }
    //         });
    //         if (addFreeProduct) {
    //             this.api.addToCart({
    //                 items: [
    //                     {
    //                         id: birthday_sale_free_prod.id,
    //                         quantity: 1,
    //                         properties: {
    //                             "bundle": 'Ashley Birthday',
    //                             "bundle_discount": 100,
    //                             "ashley_birthday": true
    //                         }
    //                     }
    //                 ]
    //             }).then(() => {
    //                 this.api.cart()
    //             }).then(() => {
    //                 const html = `<tr class="line-item"><td class="item"><div class="item-body"><div class="image-frame"> <img class="lazyautosizes lazyloaded" alt="" data-expand="-20" src="https://cdn.shopify.com/s/files/1/0064/8301/7843/products/Facecare_Products_540x.png?v=1617377195" ></div><div class="item-details"><h6 class="collections">Oils and Creams</h6><h4 class="item-title"><a href="/products/facekit-products?variant=39289612173427">FaceCare Essentials Kit</a><p class="mb-0">`+ birthday_sale_cart_note +`</p></h4><div class="d-none bold-properties bold-properties-"><div class="bold_option_line"><span class="bold_option_title">bundle</span><span class="bold_option_seperator">: </span><span class="bold_option_value">Ashley Birthday</span></div><div class="bold_option_line"><span class="bold_option_title">ashley_birthday</span><span class="bold_option_seperator">: </span><span class="bold_option_value">true</span></div><div class="bold_option_line"><span class="bold_option_title">bundle_discount</span><span class="bold_option_seperator">: </span><span class="bold_option_value">100</span></div></div><input type="hidden" name="product_id[0]" value="6555826978931"> <input type="hidden" name="variant_id[0]" value="39289612173427"> <input type="hidden" name="quantity[0]" value="1"><div class="pricing-block" data-basis-price="3500" data-comparison-basis-price=""><span class="item-total">FREE!</span></div></div></div></td><td class="quantity"></td><td class="total"><div class="pricing-block" data-basis-price="3500" data-comparison-basis-price=""><span class="item-total">FREE!</span></div></td></tr>`;
    //                 $('.v4-cart-items tbody').append(html);
    //             });
    //         }
    //     }
    // }
    //
    // removeButton(data) {
    //     if (data.items.length === 1) {
    //         let remove = false;
    //         data.items.forEach((item) => {
    //             if (item.id === birthday_sale_free_prod.id) {
    //                 remove = true;
    //             }
    //         });
    //         if (remove) {
    //             this.api.ajaxGet('cart/clear.js').then(() => {
    //                 window.location.reload();
    //             })
    //         }
    //     }
    // }
    //
    // getCartVariants(data) {
    //     let variants = [];
    //     data.items.forEach((item) => {
    //         variants.push(item.id);
    //     });
    //     return variants;
    // }
}